
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 23.96 21.914"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Layer_1-2","transform":"translate(1.083 .49)"}},[_c('g',{attrs:{"id":"Group_43964","data-name":"Group 43964"}},[_c('g',{attrs:{"id":"Rectangle_14645","transform":"translate(0 -.422)"}},[_c('rect',{attrs:{"id":"Rectangle_14696","data-name":"Rectangle 14696","width":"9.184","height":"9.184","rx":"4.588","transform":"translate(12.943 .682)","fill":"none","stroke":"#5b5be7","stroke-miterlimit":"10","stroke-width":"1.5"}})]),_c('path',{attrs:{"id":"Path_30282","data-name":"Path 30282","d":"M4.2 12.503l-4.458 7.492a.464.464 0 00.452.679h8.922a.464.464 0 00.452-.679l-4.46-7.492a.541.541 0 00-.9 0z","fill":"none","stroke":"#5b5be7","stroke-miterlimit":"10","stroke-width":"1.5"}}),_c('g',{attrs:{"id":"Rectangle_14645-2"}},[_c('rect',{attrs:{"id":"Rectangle_14697","data-name":"Rectangle 14697","width":"8.415","height":"8.415","rx":".769","transform":"translate(13.329 12.259)","fill":"none","stroke":"#5b5be7","stroke-miterlimit":"10","stroke-width":"1.5"}})]),_c('g',{attrs:{"id":"Rectangle_14645-3","transform":"translate(0 -.422)"}},[_c('rect',{attrs:{"id":"Rectangle_14698","data-name":"Rectangle 14698","width":"8.415","height":"8.415","rx":".769","transform":"translate(.448 1.059)","fill":"none","stroke":"#5b5be7","stroke-miterlimit":"10","stroke-width":"1.5"}})])])])])
          )
        }
      }
    